export default __webpack_public_path__ + "static/media/Politique-de-Confidentialite-V20240729.67a20fca.pdf";